"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BasicPagination_1 = __importDefault(require("./BasicPagination"));
/**
 * Here we add in the next and previous buttons which we display either side of the basic pagination as well as whether they should be active or disabled.
 */
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.goForward = function () {
            var _a = _this.props, currentPageIndex = _a.currentPageIndex, pageCount = _a.pageCount, setIndex = _a.setIndex;
            var indexOfNextPage = currentPageIndex + 1;
            var indexOfLastPage = pageCount - 1;
            setIndex(Math.min(indexOfNextPage, indexOfLastPage));
        };
        _this.goBack = function () {
            var _a = _this.props, currentPageIndex = _a.currentPageIndex, setIndex = _a.setIndex;
            var indexOfPrevPage = currentPageIndex - 1;
            var indexOfFirstPage = 0;
            setIndex(Math.max(indexOfFirstPage, indexOfPrevPage));
        };
        return _this;
    }
    Pagination.prototype.render = function () {
        var _a = this.props, renderPrevButton = _a.renderPrevButton, renderNextButton = _a.renderNextButton, currentPageIndex = _a.currentPageIndex, className = _a.className, pageCount = _a.pageCount;
        return (react_1.default.createElement("div", { className: className },
            renderPrevButton &&
                renderPrevButton({
                    onClick: this.goBack,
                    disabled: currentPageIndex === 0,
                }),
            react_1.default.createElement(BasicPagination_1.default, __assign({}, this.props)),
            renderNextButton &&
                renderNextButton({
                    onClick: this.goForward,
                    disabled: currentPageIndex === pageCount - 1,
                })));
    };
    return Pagination;
}(react_1.Component));
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map